"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.httpStatusCodePolicy = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _coreHttp = require("@azure/core-http");

/**
 * Because of the way AutoRest behaves when endpoint has expected status codes (outside the 200-299 range)
 * we add this policy to manually throw a RestError if the status code is outside of this range
 */
var httpStatusCodePolicy = {
  create: function create(nextPolicy) {
    return {
      sendRequest: function () {
        var _sendRequest = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(httpRequest) {
          var response;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return nextPolicy.sendRequest(httpRequest);

                case 2:
                  response = _context.sent;

                  if (!(response.status < 200 || response.status > 299)) {
                    _context.next = 5;
                    break;
                  }

                  throw new _coreHttp.RestError("HTTP status code ".concat(response.status, " indicates a failure."), _coreHttp.RestError.REQUEST_SEND_ERROR, response.status, httpRequest, response);

                case 5:
                  return _context.abrupt("return", response);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function sendRequest(_x) {
          return _sendRequest.apply(this, arguments);
        }

        return sendRequest;
      }()
    };
  }
};
exports.httpStatusCodePolicy = httpStatusCodePolicy;